import _regeneratorRuntime from 'babel-runtime/regenerator';

var _this = this;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

import * as Sentry from '@sentry/browser';
import * as actions from '../../constants';
import { callAPI } from '../../middleware';
import { getApiBaseURL } from '../../helpers';

var forgotPasswordRequest = function forgotPasswordRequest() {
  return {
    type: actions.FORGOT_PASSWORD_REQUEST
  };
};

var forgotPasswordSuccess = function forgotPasswordSuccess() {
  return {
    type: actions.FORGOT_PASSWORD_SUCCESS
  };
};

var forgotPasswordFailure = function forgotPasswordFailure(error) {
  return {
    type: actions.FORGOT_PASSWORD_FAILURE,
    error: error
  };
};

export var forgotPassword = function forgotPassword(email, productFamilyId) {
  return function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var body;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(forgotPasswordRequest());
              _context.prev = 1;
              body = {
                email: email
              };

              if (productFamilyId) {
                body = _extends({}, body, {
                  productFamilyId: productFamilyId
                });
              }

              _context.next = 6;
              return callAPI({
                method: 'POST',
                targetUrl: getApiBaseURL('v2', 'management') + '/account/password/forgot',
                body: body
              });

            case 6:
              dispatch(forgotPasswordSuccess());
              return _context.abrupt('return', true);

            case 10:
              _context.prev = 10;
              _context.t0 = _context['catch'](1);
              dispatch(forgotPasswordFailure(_context.t0));
              console.error(_context.t0);
              Sentry.captureException(_context.t0);
              return _context.abrupt('return', false);

            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[1, 10]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};